import * as React from 'react'
import { graphql } from 'gatsby'
import MastHead from '../components/organisms/MastHead/masthead'
import Breadcrumbs from '../components/organisms/Breadcrumbs/Breadcrumbs'
import { createWebpageSchema } from '../helpers/createWebpageSchema'
import TermsAndConditionsAccordion from '../components/organisms/TermsAndConditionsAccordion/TermsAndConditionsAccordion'

// Gatsby Head
//---------------------------------
export function Head({ data, pageContext, location }) {
  const title = data.contentfulPageTermsAndConditions.pageMetaTitle
  const description = data.contentfulPageTermsAndConditions.pageMetaDescription

  const webPageSchema = createWebpageSchema({
    pageTitle: title,
    pageDescription: description,
    pageUrl: `${process.env.GATSBY_HELIGUY_DOMAIN}${location?.pathname}`,
    breadcrumbs: pageContext?.breadCrumbs,
  })

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <html lang="en" />
      <meta charset="UTF-8" />
      <meta name="keywords" content="" />
      <meta name="author" content="Heliguy" />
      <link
        rel="canonical"
        href={`${process.env.GATSBY_HELIGUY_DOMAIN}${pageContext.breadcrumb.location}`}
      />
      {webPageSchema && <script type="application/ld+json">{webPageSchema}</script>}
    </>
  )
}

// Page Export
//---------------------------------
function TermsAndConditionsTemplate({ data, pageContext }) {
  const accordionData = [
    {
      header: data?.contentfulPageTermsAndConditions?.firstSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.firstSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.secondSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.secondSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.thirdSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.thirdSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.fourthSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.fourthSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.fifthSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.fifthSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.sixthSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.sixthSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.seventhSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.seventhSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.eigthSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.eigthSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.ninthSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.ninthSectionBody || '',
    },
    {
      header: data?.contentfulPageTermsAndConditions?.tenthSectionTitle || '',
      body: data?.contentfulPageTermsAndConditions?.tenthSectionBody || '',
    },
  ]

  const isPartiallyActive = ({ isPartiallyCurrent, isCurrent }) =>
    isPartiallyCurrent && isCurrent
      ? { className: 'breadcrumb__link breadcrumb__link__active' }
      : {}

  return (
    <article className="templateWrapper templateWrapper--alt">
      <section className="outer">
        <div className="inner">
          <Breadcrumbs
            crumbs={pageContext.breadCrumbs}
            crumbSeparator=" - "
            // crumbLabel={data.contentfulPageBasicPage.pageMetaTitle}
            getProps={isPartiallyActive}
          />
          <MastHead
            title={data.contentfulPageTermsAndConditions.mastheadTitle}
            subtitle={data.contentfulPageTermsAndConditions.mastheadSubtitle}
            type="Tertiary"
          />
        </div>
      </section>
      <section className="outer">
        <div className="inner">
          <div className="row between-md">
            <div className="col-xs-12">
              <ul className="list">
                {accordionData.map(({ header, body }) => (
                  <li key={header} className="margin-none">
                    <TermsAndConditionsAccordion header={header} body={body} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </article>
  )
}

export default TermsAndConditionsTemplate

// GraphQL Call
//---------------------------------
export const data = graphql`
  {
    contentfulPageTermsAndConditions {
      pageTitle
      pageMetaTitle
      pageMetaDescription
      pageSlug
      mastheadTitle
      breadcrumbTitle
      mastheadSubtitle
      firstSectionTitle
      firstSectionBody {
        raw
      }
      secondSectionTitle
      secondSectionBody {
        raw
      }
      thirdSectionTitle
      thirdSectionBody {
        raw
      }
      fourthSectionTitle
      fourthSectionBody {
        raw
      }
      fifthSectionTitle
      fifthSectionBody {
        raw
      }
      sixthSectionTitle
      sixthSectionBody {
        raw
      }
      seventhSectionTitle
      seventhSectionBody {
        raw
      }
      eigthSectionTitle
      eigthSectionBody {
        raw
      }
      ninthSectionTitle
      ninthSectionBody {
        raw
      }
      tenthSectionTitle
      tenthSectionBody {
        raw
      }
    }
  }
`
